import React, { useContext, useState } from 'react';
import { useLocation } from "react-router-dom";
import LoginBtnControl from './LoginBtnControl.js';
import NotificationBtnControl from './NotificationBtnControl.js';
import i18next from "../../i18n.js";
import { UserContext, urls, menuTypes } from '../../constants.js';
import { Button, Offcanvas } from 'react-bootstrap';
import ListFilerControl from '../forms/ListFilterControl.js';
import MainMenu from './MainMenu.js';

const Header = () => {
    const userContext = useContext(UserContext);
    const location = useLocation();
    const [showMenu, setShowMenu] = useState(false);

    const handleMenuShow = () => setShowMenu(true);
    const handleMenuClose = () => setShowMenu(false);

    return (
        <div className="header">
            <Button className='header-btn burger' onClick={handleMenuShow} />
            {(location.pathname !== urls.tasksPage && location.pathname !== urls.documentsPage) &&
                <div className="welcome">
                    {userContext?.firstName && <span className="user-name">{userContext?.firstName},</span>}
                    <span>{i18next.t("welcomeText")}</span>
                </div>
            }
            <a className='main-logo' href={urls.mainPage} />
            {(location.pathname === urls.tasksPage || location.pathname === urls.documentsPage) && <ListFilerControl />}
            <div className="header-btns">
                <NotificationBtnControl key='header-notification-btn' />
                <LoginBtnControl key='header-login-btn' />
            </div>
            <Offcanvas show={showMenu} onHide={handleMenuClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title><span className='title'>{i18next.t('navigation.mainMenuTitle')}</span></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <MainMenu menuType={menuTypes.desktop} onTabClick={handleMenuClose} />
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
};

export default Header;